<template>
	<svg :width="width" :height="height" viewBox="0 0 512 512" :fill="color" xmlns="http://www.w3.org/2000/svg">
		<g> 
			<g> 
				<path d="M413,282.988H99c-5.522,0-10-4.477-10-10v-113c0-5.523,4.478-10,10-10h314c5.522,0,10,4.477,10,10v113 C423,278.511,418.522,282.988,413,282.988z M109,262.988h294v-93H109V262.988z"></path> 
			</g> 
			<g> 
				<path d="M378.687,282.988c-0.006,0-0.013,0-0.02,0H136.001c-3.161,0-6.136-1.494-8.022-4.03c-1.887-2.536-2.464-5.814-1.556-8.842 l12.498-41.682c1.269-4.23,5.162-7.127,9.579-7.127h215c4.204,0,7.96,2.63,9.397,6.581l14.946,41.075 c0.542,1.232,0.843,2.594,0.843,4.026C388.687,278.511,384.21,282.988,378.687,282.988z M149.439,262.988h214.947l-7.89-21.682 H155.941L149.439,262.988z"></path> 
			</g> 
			<g> 
				<path d="M148.001,198.655h-16.667c-5.522,0-10-4.477-10-10s4.478-10,10-10h16.667c5.522,0,10,4.477,10,10 S153.523,198.655,148.001,198.655z"></path> 
			</g> 
			<g> 
				<path d="M159.334,362.012c-5.522,0-10-4.477-10-10v-44.714c0-5.523,4.478-10,10-10s10,4.477,10,10v44.714 C169.334,357.535,164.856,362.012,159.334,362.012z"></path> 
			</g> 
			<g> 
				<path d="M245.334,362.012c-5.522,0-10-4.477-10-10v-44.714c0-5.523,4.478-10,10-10s10,4.477,10,10v44.714 C255.334,357.535,250.856,362.012,245.334,362.012z"></path> 
			</g> 
			<g> 
				<path d="M331.334,362.012c-5.522,0-10-4.477-10-10v-44.714c0-5.523,4.478-10,10-10s10,4.477,10,10v44.714 C341.334,357.535,336.856,362.012,331.334,362.012z"></path>
			</g> 
		</g> 
	</svg>
</template>

<script>
export default {
	name: 'ACIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
